<template>
  <DropdownActionItem class="flex items-center" data-test-id="message" @click="compose">
    Message
  </DropdownActionItem>
</template>

<script>
import { defineComponent } from 'vue'
import { DropdownActionItem } from "@sportsrecruits/playbook"
import { mapGetters } from "vuex";

export default defineComponent({
  name: "MessageActionItem",
  components: { DropdownActionItem },
  computed: {
    ...mapGetters('athleteProfile', ['athleteId']),
    ...mapGetters('userData', ['isUsingProfileKey']),

    composeUrl() {
      return `/messages/compose?athlete=${this.athleteId}`
    },

    shouldOpenInNewTab() {
      return !this.isUsingProfileKey
    },
  },
  methods: {
    compose() {
      if (this.shouldOpenInNewTab) {
        window.open(this.composeUrl, '_blank')
      } else {
        window.location.href = this.composeUrl
      }
    },
  },
})
</script>
